<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/maintain/execute/item/page" getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('mujubaoyangdanhao')">
						<el-input disabled v-model="$attrs.item.no"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('mujubianhao/mingcheng')">
						<yi_cross_select disabled multiple :selectTitle="'no,name'" :component="'web_base_mould_list'" :ids.sync="$attrs.item.mouldIds">
						</yi_cross_select>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('baoyangleixing')">
						<el-select disabled v-model="$attrs.item.type">
							<el-option :label="$t('shoucibaoyang')" :value="0"></el-option>
							<el-option :label="$t('dingqibaoyang')" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="!isStatus" :label="$t('baoyangpingjia')">
						<el-input @input="change($event)" maxlength="400" v-model="remark" :autosize="{ minRows: 1, maxRows: 4 }">
						</el-input>
					</el-form-item>
					<el-form-item v-if="isStatus" class="noborder" :label="$t('baoyangpingjia')">
						<el-input disabled maxlength="400" v-model="remark" :autosize="{ minRows: 1, maxRows: 4 }">
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button v-if="!isStatus" size="mini" @click="beforeAdd" type="primary">
							{{ $t('baocun') }}
						</el-button>
					</el-form-item>
					<yi_curd_expand_button></yi_curd_expand_button>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.editObj.maintainId = $attrs.item.id; yt.editObj.status = 1; yt.req('POST', '/web/maintain/execute/item/beginAll', null, refresh)" type="primary" v-if="!isAllStarted" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具履历-一键开始' } }">
					{{ $t('yijiankaishi') }}
				</el-button>
				<el-button size="mini" @click="yt.editObj.maintainId = $attrs.item.id; yt.editObj.status = 2; yt.req('POST', '/web/maintain/execute/item/finishAll', null, refresh)" type="primary" v-if="!isAllFinish" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具履历-一键完成' } }">
					{{ $t('yijianwancheng') }}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="scope.row.status == 0" type="text" @click="startItem(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具履历-开始保养' } }">
							{{ $t('kaishibaoyang') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="scope.row.status == 1" type="text" @click="finishItem(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具履历-完成保养' } }">
							{{ $t('wanchengbaoyang') }}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_mold_management_maintenance_execution_item',
	data() {
		return {
			disabled: false,
			remark: '',
			statusItem: null,
			columns: [{
				label: 'baoyangneirong',
				prop: 'content',
				width: 150
			}, {
				label: 'zhuyishixiang',
				prop: 'carefully',
				width: 150
			}, {
				label: 'beizhu',
				prop: 'remark',
			}, {
				label: 'zhuangtai',
				type: 'tag',
				prop: 'status',
				tags: {
					0: {
						color: '#F56C6C',
						text: this.$t('weibaoyang')
					},
					1: {
						color: '#E6A23C',
						text: this.$t('baoyangzhong')
					},
					2: {
						color: '#67C23A',
						text: this.$t('yiwancheng')
					}
				},
			}, {
				label: 'caozuo',
				type: 'slot',
				width: 150,
				fixed: 'right'
			}]
		};
	},
	computed: {
		isAllStarted() {
			for (var i = 0; i < this.yt.list.length; i++) {
				if (this.yt.list[i].status == "0") {
					return false
				}
			}
			return true
		},
		isAllFinish() {
			for (var i = 0; i < this.yt.list.length; i++) {
				if (this.yt.list[i].status == "1") {
					return false
				}
			}
			return true
		},
		isStatus() {
			for (var i = 0; i < this.yt.list.length; i++) {
				console.log('jjjjj', this.yt.list)
				if (this.yt.list[i].status == 1 || this.yt.list[i].status == 0) {
					return false
				}
			}
			return true
		},
	},
	created() {
		// this.getPage()
		setTimeout(() => {
			this.remark = this.$attrs.item.remark
			this.yt.conditions = {
				maintainId: this.$attrs.item.id,
			}
			this.yt.get(1);
		}, 300)

	},
	methods: {
		refresh() {
			this.yt.get(1);
			this.utils.event_hub.$emit('MOLD_RESUME_MAINTENANCE_REFRESH');
		},
		addComment() {
			this.$attrs.item.remark = this.remark;
			this.yt.get(1);
			this.utils.event_hub.$emit('MOLD_RESUME_MAINTENANCE_REFRESH');
		},
		finishItem(row) {
			this.http.post('/web/maintain/execute/item/finish', {
				id: row.id,
				status: 2
			}).then(res => {
				this.refresh()
				this.$message.success(this.$t(res.msg))
				this.yt.get(1);
			}).catch(error => {
				this.$message.error(this.$t(error))
			})
		},
		beforeAdd() {
			this.http.post('/web/maintain/addRemark', {
				id: this.$attrs.item.id,
				remark: this.remark,
			}).then(res => {
				this.$message.success(this.$t(res.msg))
				this.addComment()
				// console.log('kkkk', this.equipmentList)
			}).catch(error => {
				this.$message.error(this.$t(error))
			})
		},
		// 一键开始
		startOne() {
			// console.log('hhhh',row)
			this.http.post('/web/maintain/execute/item/beginAll', {
				maintainId: this.$attrs.item.id,
				status: 1
			}).then(res => {
				this.$message.success(this.$t(res.msg))
				this.refresh()
			}).catch(error => {
				this.$message.error(this.$t(error))
			})
		},
		startItem(row) {
			console.log('jkjjj', row)
			this.statusItem = row.status
			this.http.post('/web/maintain/execute/item/begin', {
				id: row.id,
				status: 1
			}).then(res => {
				this.$message.success(this.$t(res.msg))
				this.yt.get(1);
				// console.log('kkkk', this.equipmentList)
			}).catch(error => {
				this.$message.error(this.$t(error))
			})
		},
		// 重置
		clear() {
			this.yt.conditions = {
				pageNum: 1,
				pageSize: 10
			}
			this.yt.get(1)
		},
	}
};
</script>
